<ion-header>
  <ion-toolbar color="transparent">
    <h1 [hidden]="showBtnBack">{{ title }}</h1>
    <div [hidden]="!showBtnBack">
      <ion-img [src]="'assets/icon/arrow.svg'" (click)="onClick()"></ion-img>
      <h1>{{ title }}</h1>
    </div>
  </ion-toolbar>
</ion-header>
